export default {
    titles: {
        dashboard: 'Dashboard'
    }
}
